import { pattern, max, maxSelected, custom, email, maxLength } from '@carboledger/ui';
import { REGEX } from '@/config/regex.constants';
import { MAX_ALLOCATION_PREFERENCES } from '@/config/formOptions';
import { getTranslation } from '@/lib/utils/i18n';

// Rules shared by more than one entity form; a slice keeps only its own fields' rules.

// An address box, wherever one appears — length first, then format.
export const EMAIL_MAX_LENGTH = 320;

export const emailRule = [
  maxLength(
    EMAIL_MAX_LENGTH,
    getTranslation('VALIDATION_EMAIL_MAX_LENGTH', { max: EMAIL_MAX_LENGTH }),
  ),
  email(getTranslation('VALIDATION_EMAIL')),
];

// The editable half of a reference id — same box, same rule, on every form that has one.
export const referenceIdNumberRule = [
  pattern(REGEX.REFERENCE_ID_NUMBER, getTranslation('VALIDATION_REFERENCE_ID_NUMBER')),
];

const MAX_PERCENTAGE = 100;

// Quantities, densities, emissions and savings — anything that cannot go below zero.
export const positiveNumberRule = [
  pattern(REGEX.POSITIVE_DECIMAL, getTranslation('VALIDATION_POSITIVE_NUMBER')),
];

// A percentage cannot exceed 100; `max` is empty-safe, so an optional field stays optional.
export const percentageRule = [
  ...positiveNumberRule,
  max(MAX_PERCENTAGE, getTranslation('VALIDATION_PERCENTAGE_MAX', { max: MAX_PERCENTAGE })),
];

// Without it a cross-category entry stores no declaration quantity at all — see the slice docs.
export const densityRequiredRule = [
  ...positiveNumberRule,
  custom(Boolean, getTranslation('SHIPMENT_FORM_DENSITY_REQUIRED_FOR_ENTRY')),
];

// The GHG breakdown terms, which can net negative.
export const signedNumberRule = [
  pattern(REGEX.SIGNED_DECIMAL, getTranslation('VALIDATION_NUMBER')),
];

// The three-country cap the contract and shipment forms both enforce.
export const allocationPreferenceRule = [
  maxSelected(
    MAX_ALLOCATION_PREFERENCES,
    getTranslation('COMMON_INVALID_ALLOCATION_MAX', { max: MAX_ALLOCATION_PREFERENCES }),
  ),
];
